import { c as _c } from "react/compiler-runtime";
import type { EventNumber, Participant } from '@svs/nova-poolbetting/schema/sport';
import { CouponEventParticipants } from '@svs/nova-poolbetting/ui/Coupon';
import type { ReactNode } from 'react';
type ParticipantInfoRowProps = {
  eventParticipants?: (Participant | undefined)[];
  eventNumber: EventNumber;
  eventDescription: string;
  nrOfRows: number;
};

/**
 * Renders a row displaying event participant information in the coupon overview.
 *
 * @param props - Component properties containing event details and participants
 * @param props.eventParticipants - Array of participants for the event (may contain undefined values)
 * @param props.eventNumber - The event number to display
 * @param props.eventDescription - Textual description of the sporting event being displayed
 * @param props.nrOfRows - Total number of betting coupons, used to determine participant name display size
 * @returns A React node displaying the participant information row
 */
export default function ParticipantInfoRow(t0) {
  const $ = _c(11);
  const {
    eventParticipants,
    eventNumber,
    eventDescription,
    nrOfRows
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["grid", "grid-cols-2", "[grid-template-areas:'eventNumber_eventParticipants']", "grid-cols-[max-content_auto]", "sm:text-xs", "pt-[6px]", "pb-[6px]", "pl-[12px]", "pr-[12px]", "lg:pl-0", "lg:pr-0", "even:bg-grey-warm-80", "gap-2", "text-sm"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const classNames = t1;
  let t2;
  if ($[1] !== eventNumber) {
    t2 = <div>{eventNumber}</div>;
    $[1] = eventNumber;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = nrOfRows > 6 ? "short" : "full";
  let t4;
  if ($[3] !== eventDescription || $[4] !== eventParticipants || $[5] !== t3) {
    t4 = <div><CouponEventParticipants className="flex gap-2 sm:text-xs" participants={eventParticipants} eventDescription={eventDescription} nameSize={t3}>-</CouponEventParticipants></div>;
    $[3] = eventDescription;
    $[4] = eventParticipants;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== eventNumber || $[8] !== t2 || $[9] !== t4) {
    t5 = <div key={eventNumber} className={classNames.join(" ")}>{t2}{t4}</div>;
    $[7] = eventNumber;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}